// extracted by mini-css-extract-plugin
module.exports = {"appsWrapper":"PI24PLtw","apps":"ZbS4ZgRp","appsEmpty":"taxdYJ1a","appsSearchEmpty":"_9WdCIL8z","appsDelimiter":"_78tAAzzn","list":"Cm6iHQNl","empty":"RppFVv0S"};